import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { ContainerStatusEnum } from '@gtpl/shared-models/common-models';

export class ContainerDTO {
  @ApiProperty()
  @IsNotEmpty({message:"ContainerId should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  containerId: number;

  @ApiProperty()
  @IsNotEmpty({message:"ContainerNumber should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  containerNumber: string;

  @ApiProperty()
  @IsNotEmpty({message:"so Number should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  saleOrderId: number;

  @ApiProperty()
  @IsAlphanumeric()
  @IsOptional()
  lineSeal: string;

  @ApiProperty()
  @IsAlphanumeric()
  @IsOptional()
  eSeal: string;

  @ApiProperty()
  @IsAlphanumeric()
  @IsOptional()
  containerStatus: ContainerStatusEnum;

  @ApiProperty()
  @IsAlphanumeric()
  @IsOptional()
  loadingDate: Date;

  @ApiProperty()
  @IsAlphanumeric()
  @IsOptional()
  actualDate: Date;

  @ApiProperty()
  @IsAlphanumeric()
  @IsOptional()
  vehicleNumber: string;

  @ApiProperty()
  @IsAlphanumeric()
  @IsOptional()
  driverName: string;

  @ApiProperty()
  @IsAlphanumeric()
  @IsOptional()
  driverPhoneNumber: string;

  @ApiProperty()
  @IsAlphanumeric()
  @IsOptional()
  assignedBy: string;

  @ApiProperty()
  loadingSheet_number: number;

  @ApiProperty()
  isActive: boolean;

  @ApiProperty()
  scac:string
  
  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;
    // containerItems: any;
   
}

